import { useQueryWithStore, GET_LIST } from "react-admin";
import { useSelector } from "react-redux";
import moment from "moment";

import { useSeason } from "../../common/inputs/SeasonSelector";

export const useQualificationsWithSettings = (participantId) => {
  const seasonId = useSeason();
  const startOfToday = moment().startOf("day").toISOString();

  const query = {
    type: GET_LIST,
    resource: 'qualifications',
    payload: {
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'seasonId', order: 'DESC' },
      filter: {
        participantId,
        qualificationCategory: {
          types: { inq: ['Official', 'Scorekeeper'] }
        },
        or: [
          { seasonId },
          { expiry: { gte: startOfToday } },
          { expiry: { eq: null } }
        ],
        _include: [{
          relation: 'office',
          scope: {
            scope: 'Tenant',
            include: 'branchSettings',
          },
        }],
      }
    }
  };

  const queryKey = JSON.stringify(query);
  const cachedQualifications = useSelector(state => state.admin.customQueries[queryKey]?.data);

  const { data, loading, loaded, error } = useQueryWithStore(query, {
    enabled: !cachedQualifications && !!participantId,
    action: 'CUSTOM_QUERY'
  });

  return {
    data: cachedQualifications || data,
    loaded: !!cachedQualifications || loaded,
    loading,
    error
  };
};
